const antdConfig = {
	colorPrimary: '#0081C9',
	colorError: '#dc3545',
	fontFamily: 'Source Sans Pro, sans-serif',
	fontWeightStrong: 500,
	fontSize: 15,
	colorBgMask: 'rgba(0, 0, 0, 0.85)',
};

export default antdConfig;